export default "__VITE_ASSET__DPcwLjFC__"